import index from './pages/index'

const routes = [
    {
        path: '/services',
        name: 'Services',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/service/routes.js